import { recipeImages } from '#shared/models/images'
import { sampleSize } from 'es-toolkit'
import type { RecipeKey, RecipeKeyWithoutIndex, RecipeLayout } from '~/types/layouts'
import type { ExtendedBlogPostProps } from '~/types/elementsUi'
import type { ContentImage } from '~/types/images'
import { omittedRecipeKeys } from '~/models/hardcodedArrays'
import type { RouteLocationRaw } from '#vue-router'

function getBlogPosts<T extends RecipeLayout>(
  posts: [string, T][],
  imageMap: Record<string, ContentImage>,
  baseUrl: string
): ExtendedBlogPostProps[] {
  const size = Math.min(posts.length, 3)
  const randomItems = sampleSize(posts, size)

  return randomItems.map<ExtendedBlogPostProps>((item) => {
    return {
      key: item[0],
      to: {
        name: `${baseUrl}-${item[0]}`
      } as RouteLocationRaw,
      title: Array.isArray(item[1].title) ? item[1].title[0] : item[1].title,
      description: item[1]['short-description'],
      date: item[1]['date-published'],
      image: imageMap[item[0]]
    }
  })
}

export function getOtherRecipes(
  omitKey?: RecipeKeyWithoutIndex
): Ref<ExtendedBlogPostProps[]> {
  const stateId = useRoute().name

  const { t, tm } = useI18n()
  const allRecipes: Record<RecipeKey, RecipeLayout> = tm('recepten')

  const omitKeys = new Set(omitKey ? [omitKey, ...omittedRecipeKeys] : omittedRecipeKeys)

  const filteredPosts = Object.entries(allRecipes).filter(
    ([recipeKey]) => !omitKeys.has(recipeKey as RecipeKey)
  )

  return useState(`recipes:${stateId}`, () => {
    const recipes = getBlogPosts(filteredPosts, recipeImages, 'recepten')
    return recipes.map((mappedRecipe) => {
      const [_key, recipe] = filteredPosts.find(([key]) => key === mappedRecipe.key)!
      return {
        ...mappedRecipe,
        hideDate: true,
        badges: [
          {
            icon: 'fa-flag',
            title: t(`recipes-data.cuisines.${recipe['recipe-cuisine']}`),
            color: 'info'
          },
          {
            icon: 'fa-utensils',
            title: recipe['recipe-category'],
            color: 'success'
          }
        ]
      }
    })
  })
}
